'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCompass = function IoCompass(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5c0-3 0.8-5.9 2.1-8.4-1.2-1-2.1-2.4-2.1-4.1 0-2.7 2.3-5 5-5 1.7 0 3.1 0.9 4.1 2.1 2.5-1.3 5.4-2.1 8.4-2.1z m-15 5c0 0.8 0.4 1.6 1 2 1-1.3 2.2-2.5 3.5-3.5-0.4-0.6-1.2-1-2-1-1.4 0-2.5 1.1-2.5 2.5z m25.6 23.1c2.8-2.8 4.4-6.6 4.4-10.6s-1.6-7.8-4.4-10.6-6.6-4.4-10.6-4.4-7.8 1.6-10.6 4.4-4.4 6.6-4.4 10.6 1.6 7.8 4.4 10.6 6.6 4.4 10.6 4.4 7.8-1.6 10.6-4.4z m-3.1-20.6s-4.2 10.2-5.6 11.9-9.4 8.1-9.4 8.1 4.2-10.3 5.6-11.9 9.4-8.1 9.4-8.1z' })
        )
    );
};

exports.default = IoCompass;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/compass.js
// module id = 2030
// module chunks = 0